import { render, staticRenderFns } from "./MspGaraItem.vue?vue&type=template&id=a663291e"
import script from "./MspGaraItem.vue?vue&type=script&lang=js"
export * from "./MspGaraItem.vue?vue&type=script&lang=js"
import style0 from "./MspGaraItem.vue?vue&type=style&index=0&id=a663291e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports